import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface ICompletedCollectionTransacitonsToolbar {
	onDeleteButtonClickedHandler: () => void
	onRollbackAfterCollectionButtonClickedHandler: () => void
}

export const CompletedCollectionTransacitonsToolbar: FC<ICompletedCollectionTransacitonsToolbar> = ({
	onDeleteButtonClickedHandler,
	onRollbackAfterCollectionButtonClickedHandler
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Delete"
					raised
					onClickHandler={onDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Danger}
				/>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Rollback after Collection"
					raised
					onClickHandler={onRollbackAfterCollectionButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Secondary}
				/>
			</Toolbar>
		</AppBar>
	);
};
